import * as React from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { Grid } from '../../common/Grid/Grid.esm.js';
import { NvMarkdownInline, NvHeading } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './BannerActionBlock.module.esm.js';

var BannerActionBlock = function (_a) {
    var _b;
    var id = _a.id, _c = _a.fields, primaryLink = _c.primaryLink, secondaryLink = _c.secondaryLink, heading = _c.heading, internalName = _c.internalName, theme = _c.theme, decorativeShape = _c.decorativeShape, dataCy = _a["data-cy"];
    var className = classNames(styles.root, (_b = {},
        _b[styles[theme]] = theme,
        _b));
    var isWhiteButton = ['buttermilkOnCobalt'].includes(theme);
    return (React.createElement(BaseSectionWithAnalyticsContext, { className: classNames(className), "data-cy": dataCy, id: id, sectionName: internalName },
        decorativeShape && React.createElement(BaseNucleobaseComponent, { source: decorativeShape }),
        React.createElement(Grid, null,
            React.createElement("div", { className: styles.wrapper },
                React.createElement(NvMarkdownInline, { className: styles.header, element: "h2", elementWrapper: NvHeading, level: 1 }, heading),
                React.createElement("div", { className: styles.buttonWrapper },
                    primaryLink && (React.createElement(BaseNucleobaseComponent, { classes: { link: classNames('nv-button', styles.button, { 'nv-button-white': isWhiteButton }) }, source: primaryLink })),
                    secondaryLink && (React.createElement(BaseNucleobaseComponent, { classes: { link: classNames('nv-button', styles.button, { 'nv-button-white': isWhiteButton }) }, source: secondaryLink })))))));
};

export { BannerActionBlock as default };
//# sourceMappingURL=BannerActionBlock.esm.js.map
